module.exports = __webpack_public_path__ + "static/sidebar-ddc4d5737b4fba8ee31fe1db0f849aab.jpg";